// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__mX7jZ","icon":"styles_icon__dP67v"};